import { Component } from '@angular/core';

@Component({
  selector: 'app-registration-policy',
  standalone: false,
  templateUrl: './registration-policy.component.html',
  styleUrl: './registration-policy.component.scss'
})
export class RegistrationPolicyComponent {

}
